<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { FormDefDependenciesReadModel } from "@Alternatives/Forms/Domain/readmodels";

        @Component({
        props: {
            readModel: {
                type: Object,
                required: true,
                default: null
            }
        }
    })
    export default class FormDependenciesList extends Vue
    {
        get rm(): FormDefDependenciesReadModel { return this.$props.readModel as FormDefDependenciesReadModel; }
    }

</script>

<template>
    <div>

        <h4 v-if="!rm">
            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
        </h4>
        <div v-if="rm">
            <div class="card" v-if="rm.RequestPages.length > 0">
                <div class="card-header">
                    RequestPages ({{rm.RequestPages.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="p in rm.RequestPages" :key="p.Id">
                        <a class="text-primary" target="_blank" v-sanitizedHref="p.Url">{{p.Name}}</a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="rm.Reports.length > 0">
                <div class="card-header">
                    Reports ({{rm.Reports.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="r in rm.Reports" :key="r.Id">
                        <a class="text-primary" target="_blank" v-sanitizedHref="r.Url">{{r.Name}}</a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="rm.Notifications.length > 0">
                <div class="card-header">
                    Notifications ({{rm.Notifications.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="n in rm.Notifications" :key="n.Id">
                        <span>{{n.Name}}</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>      


<style scoped>
</style>